import { Typography } from '@screentone/core';

interface QueryDisplayProps {
  query: Record<string, unknown>;
  label?: string;
}

const QueryDisplay = ({ query, label = 'Query' }: QueryDisplayProps) => (
  <details>
    <summary>
      <Typography variant="header4" inline>
        {label}
      </Typography>
    </summary>
    <Typography size="sm">
      <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{JSON.stringify(query, null, 2)}</pre>
    </Typography>
  </details>
);

export default QueryDisplay;
